module.exports = "<div class=\"download-tooltip tv\">\n    <div class=\"info-download-kit animated bounce\" connectqa-devices=\"download-tooltip\">\n        <div class=\"logo-holder centerFlex\">\n            <i class=\"icon icon-avira-logo \"></i>\n        </div>\n        <div class=\"tooltip\" >\n            <p translate=\"cw.download-tooltip\"></p>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./scripts/directives/dashboard/download-tooltip/download-tooltip.html
// module id = JiTH
// module chunks = 0